<template>
  <v-layout>
    <v-flex xs12>
      <v-container grid-list-md fluid style="padding: 0;">
        <v-layout row wrap>
          <v-flex
                  v-for="letter in letters"
                  :key="letter.id"
                  xs6
                  sm4
                  md3
                  lg2
                  v-on:click="$emit('change', letter)"
                  class="item"
          >
            <v-card class="letter-card">
              <v-card-title primary-title>
                <h3 class="display-3 text-xs-center mb-0 grey--text text--lighten-1">{{ letter.uppercase }} {{ letter.lowercase }}</h3>
                <h2 class="display-1 text-xs-center mb-0" v-if="letter.transliteratedLetter">{{ letter.transliteratedLetter.name }}</h2>
                <h2 class="text-xs-center mb-0 red--text" style="line-height: 40px;" v-if="!letter.transliteratedLetter">no transliteration</h2>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['letters']
}
</script>

<style>
  .letter-card {
    cursor: pointer;
  }
  .letter-card h2, .letter-card h3 {
    width: 100%;
  }
</style>
